module.exports = __webpack_public_path__ + "img/icono_3.a274bce5.svg";